import styled from "styled-components";
import { grayColors } from "../../../../../../themes/architecture/gray-colors";

export const ClientSettingsSectionIconDefaultBox = styled.span`
    color: ${grayColors.gray113};
    width: 20px;
    height: auto;
`